import { useFadeIn } from '@/hooks/useFadeIn';

export default function IconAccess() {
  const heading = useFadeIn({ direction: 'up' });
  const card = useFadeIn({ direction: 'up', delay: 300 });

  return (
    <section id="access" className="bg-gray-50 py-20">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div ref={heading.ref} style={heading.style}>
          <h2 className="font-serif text-gray-900 text-3xl md:text-4xl text-center mb-4">
            アクセス
          </h2>
          <p className="text-center text-lg text-gray-700 mb-12">
            場所:大通駅直結 moyukSAPPORO2F
          </p>
        </div>

        <div ref={card.ref} style={card.style}>
          <div className="bg-white rounded-2xl overflow-hidden">
            <div className="grid md:grid-cols-2 min-h-[420px]">
              {/* 左：住所・電話 */}
              <div className="p-8 md:p-12 flex flex-col justify-center">
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 font-serif">
                  さいわいデンタルクリニック<br />
                  moyuk SAPPORO
                </h3>
                <p className="text-sm text-gray-600 mb-6 leading-relaxed">
                  札幌市営地下鉄 大通駅直結<br />
                  お買い物やお仕事帰りに、立ち寄りやすい場所です。
                </p>
                <div className="space-y-1 text-sm text-gray-700 mb-6">
                  <p>〒060-0062</p>
                  <p>北海道札幌市中央区南2条西3丁目20番地</p>
                  <p>moyuk SAPPORO 2F</p>
                  <a
                    href="tel:050-1809-4594"
                    className="text-lg font-bold mt-3 inline-block hover:underline cursor-pointer text-gray-900"
                  >
                    050-1809-4594
                  </a>
                </div>
                <a
                  href="https://saiwaidental.jp/moyuk"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1 font-medium text-sm whitespace-nowrap text-gray-900 hover:underline cursor-pointer"
                >
                  診療時間・院内写真は医院HPで確認できます
                  <i className="ri-arrow-right-line text-xs"></i>
                </a>
              </div>

              {/* 右：建物画像 */}
              <div className="h-auto">
                <img
                  alt="moyuk SAPPORO クリニック外観"
                  className="w-full h-auto object-contain"
                  src="https://storage.readdy-site.link/project_files/c00d6376-89f2-4ee7-9f33-9907e12ecb61/003738f3-fbe7-4391-8b25-c71048db65fc_ChatGPT-Image-2026116-21_56_45.png?v=5a42efdf912ffee479af8f49b6bd04e4"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}